<template>
  <div class="offer-page">
    <TheBreadcrumb :pages="arianeRoute" />
    <HeaderPage :page="currentPageInfo" />
    <SearchResults :with-search="false">
      <template #title>
        <h2 class="title-strat">Les offres du moment</h2>
      </template>
      <template #results>
        <OfferContainer
          :items="offers"
          no-result-text="Aucune offre disponible"
        />
      </template>
    </SearchResults>
    <ThePagination
      :total-pages="getPagesCount"
      :current-page="getCurrentPage"
      :go-to="changePageTo"
    />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  middleware: async (to) => {
    const offersStore = useOffersStore()

    await offersStore.fetchOffers(getPageQuery(to))
    if (offersStore.getPagesCount === -1) {
      return navigateTo(to.path, { replace: true })
    }
  },
})

const offersStore = useOffersStore()
const { offers, getPagesCount, getCurrentPage } = storeToRefs(offersStore)

const link = useLinkPrevNext({
  currentPage: getCurrentPage,
  pagesCount: getPagesCount,
})

const arianeRoute = ref([
  {
    title: 'Toutes les offres',
    route: '',
  },
])

const breadcrumbSchema = useBreadcrumbSchema({
  arianeRoute,
})

useHead({
  title: 'Découvrez les offres et promo PlayStation en exclu',
  link,
  script: [breadcrumbSchema],
})

useSeoMeta({
  title: 'Toutes les offres We Are PlayStation',
  description:
    'Retrouvez toutes les offres et bons plans sur les meilleurs jeux vidéo du moment.',
  ogTitle: 'Toutes les offres We Are PlayStation',
  ogDescription:
    'Retrouvez toutes les offres et bons plans sur les meilleurs jeux vidéo du moment.',
  ogImage: 'https://www.weareplaystation.fr/img/toutes-les-offres.jpg',
})

const currentPageInfo = {
  title: 'Toutes les offres',
  image: '/img/toutes-les-offres.jpg',
  titleSmall: 'toutes les',
  titleBig: 'offres',
  description:
    'Retrouvez toutes les offres et bons plans sur les meilleurs jeux vidéo du moment.',
}

const changePageTo = async (index = 1) => {
  if (index > 0) {
    await offersStore.fetchOffers(index)
  }
}
</script>

<style lang="scss" scoped>
.offer-page {
  min-height: 100vh;
  padding-bottom: 10rem;
}
</style>
